import React from "react";
import { ContractRepoPage } from "./ContractRepoPage";

export function ContractsPage() {
  return <ContractRepoPage isLegacy={false} />;
}
